import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useCommonStore from 'store/useCommonStore';
import styled from 'styled-components';
import { PlatformCode } from 'type/common';
import { IMatchDB } from 'utils/dummy';
import ResultNone from './common/ResultNone';
import TableRow from './common/table/TableRow';
import TableSkeleton from './common/table/TableSkeleton';

interface ITableBody {
	data: IMatchDB[];
	loading: boolean;
}

const TableBody = ({ data, loading }: ITableBody) => {
	const { platform } = useCommonStore();

	const navigate = useNavigate();
	const location = useLocation();

	const clickRow = (row_data: IMatchDB) => {
		const params = new URLSearchParams(location.search);
		params.append('rm', 'm');
		params.append('pk', row_data?.platform_pk as string);
		params.append('p', platform.code as PlatformCode);
		navigate({ search: params.toString() });
	};

	return (
		<Body>
			{/* 로딩 */}
			{loading &&
				new Array(25).fill(null).map((item, idx) => <TableSkeleton key={idx} />)}
			{/* 결과 존재 */}
			{!loading &&
				data?.length > 0 &&
				data?.map((item: IMatchDB, idx: number) => (
					<TableRow key={idx} data={item} row_idx={idx} />
				))}
			{/* 결과 없음 */}
			{!loading && data?.length === 0 && <ResultNone type="match" />}
		</Body>
	);
};

const Body = styled.div`
	width: max-content;
	min-width: 100%;
	height: max-content;
	min-height: calc(100% - 424px);
	padding: 16px;
	background-color: ${({ theme }) => theme.colors.gray.gray05_bg};
`;

export default React.memo(TableBody);
